// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import 'es6-promise/auto'

import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import router from './router'

import { store } from './store/store'

import lodash from 'lodash'
import VueLodash from 'vue-lodash/dist/vue-lodash.min'

import axios from 'axios'
import VueAxios from 'vue-axios'

import VueLazyload from 'vue-lazyload'
import Vue2Filters from 'vue2-filters'
import VueMoment from 'vue-moment'

Vue.router = router
Vue.use(VueLodash, lodash)
Vue.use(Vuetify)
Vue.use(VueLazyload)
Vue.use(Vue2Filters)
Vue.use(VueMoment)
Vue.config.productionTip = false
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyB9K3QE2QtxtCXIkiwy9vyecmllsZzn7mM',
//     libraries: 'places' // This is required if you use the Autocomplete plugin
//     // OR: libraries: 'places,drawing'
//     // OR: libraries: 'places,drawing,visualization'
//     // (as you require)
//   }
// })
Vue.use(VueAxios, axios)

Vue.filter('thumbnailURL', function (value) {
  if (typeof value === 'undefined') { return '' }
  var s = value.replace('upload/', 'upload/c_scale,w_300/')
  return s
})
Vue.filter('resizedURL', function (value, width) {
  if (typeof value === 'undefined') { return '' }
  var s = value.replace('upload/', 'upload/c_scale,w_' + width + '/')
  return s
})

/* eslint-disable no-new */
new Vue({
  el: '#app-vivid-arts-pro',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js